<template>
  <component-wrapper class="country-selection-fi">
    <grid-container-fi :container="false">
      <div class="country-selection-fi__header fi-col-span-12">
        <headline-fi
          v-if="title"
          :size="setTitleFontSize"
          class="country-selection-fi__title"
          tag="div"
          color="brand"
          :html-content="title"
        />
        <headline-fi
          v-if="subtitle"
          :size="setHeadlineFontSize"
          class="country-selection-fi__subtitle"
          tag="h1"
          :html-content="subtitle"
        />
        <!-- eslint-disable vue/no-v-html -->
        <p
          v-if="description"
          class="country-selection-fi__description"
          v-html="description"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </grid-container-fi>

    <country-selection-list-fi ref="continents" />
  </component-wrapper>
</template>

<script>
import { HeadlineFi } from 'atoms';
import axios from 'axios';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import CountrySelectionListFi from 'components/country-selection-list-fi/CountrySelectionListFi';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import breakpointMixin from 'mixins/breakpointMixin';

export default {
  name: 'CountrySelectionFi',
  components: {
    HeadlineFi,
    ComponentWrapper,
    GridContainerFi,
    CountrySelectionListFi,
  },
  mixins: [breakpointMixin],
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    customData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localCustomData: null,
      data: {},
      showOnlyCountriesWithLocalization: false,
    };
  },
  computed: {
    title() {
      return this.$dict.get('global-Labels.Country-Selection.Title');
    },
    subtitle() {
      return this.$dict.get('global-Labels.Country-Selection.Subtitle');
    },
    description() {
      return this.$dict.get('global-Labels.Country-Selection.Description');
    },
    setTitleFontSize() {
      if (this.isMD) return 30;
      if (this.isSM) return 24;
      return 21;
    },
    setHeadlineFontSize() {
      if (this.isMD) return 60;
      return 36;
    },
    cData() {
      if (IS_SHOWROOM) {
        return this.localCustomData;
      }

      return this.customData;
    },
    breadcrumbData() {
      let data = [];
      if (this.cData?.breadcrumb) {
        data = this.cData.breadcrumb;
      }
      return data;
    },
  },
  created() {
    this.localData();
    this.$store.commit('navigation/IS_COUNTRY_SELECT_PAGE', true);
  },
  methods: {
    async localData() {
      if (IS_SHOWROOM) {
        const devDataUrl = '/__mocks__/customData/breadcrumbCountrySelection.json';

        const { data: naviData } = await axios.get(devDataUrl);

        this.localCustomData = naviData.customData;
      }
    },
    countryUrl(url, language) {
      if (language) {
        return `${url}/${language.toLowerCase()}`;
      }
      return url;
    },
    scrollToContinents() {
      this.$smoothScroll({
        scrollTo: this.$refs.continents.$el,
        duration: 500,
        updateHistory: false,
        offset: -80,
      });
    },
  },
};
</script>

<style lang="scss">
@import './country-selection-fi';
</style>
